import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useUserContext } from '../providers/UserProvider';
import getAuthenticatedRedirectUrl from '../utils/getAuthenticatedRedirectUrl';
import useFeatureFlag from './useFeatureFlag';

/**
 * Redirects to the sign in page if the user is not authenticated.
 */
const useAuthenticatedRoute = (isAuthenticatedRoute: boolean = true): void => {
  const router = useRouter();
  const { user } = useUserContext();

  const isAuthMigrationEnabled = useFeatureFlag('auth-migration');
  useEffect(() => {
    if (!user?.id && isAuthenticatedRoute) {
      router.push(getAuthenticatedRedirectUrl(router.asPath, router.query, isAuthMigrationEnabled));
    }
  }, [router, user?.id, isAuthenticatedRoute, isAuthMigrationEnabled]);
};

export default useAuthenticatedRoute;
